import React from 'react';
import {useParams} from 'react-router-dom';

import ClientAppContainer from './context/ClientAppContainer';
import ClientAppInfo from './ClientAppInfo';
import useTitle from '@/hook/useTitle';

function ClientAppPage() {
    const {clientAppId} = useParams();
    useTitle('Api 群组详细 - 系统管理');

    return (
        <div style={{overflowY: 'auto'}}>
            <ClientAppContainer clientAppId={clientAppId}>
                <ClientAppInfo />
            </ClientAppContainer>
        </div>
    );
}

export default ClientAppPage;
